import React, { useState, useEffect, useContext } from 'react';
import classes from "../Pages.module.css";
import { Row, Col, Skeleton, message } from "antd";
import { useNavigate, useLocation } from 'react-router-dom';
import DataContext from '../../../Context/dataContext';
import SalesTable from "./SalesTable";
import axios from 'axios';

const AllUsers = () => {
  const employeeData = useContext(DataContext);
  const [columns, setColumns] = useState([]);
  const [allRows, setAllRows] = useState(null);
  const [pendingRows, setPendingRows] = useState(null);
  const [completedRows, setCompletedRows] = useState(null);
  const [type, setType] = useState("all");
  const [ft, setFT] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dFilter, setDFilter] = useState("all");
  const [typeChanged, setTypeChanged] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Get usersList from location state
  useEffect(() => {
    if (location.state && location.state.usersList) {
      setColumns([
        { name: "SNO", title: "SNo" },
        { name: "spec_code", title: "Email" },
        { name: "user_name", title: "User Name" },
        { name: "manage_rights", title: "Actions" } // Changed name to match the data property
      ]);

      // Process the user data
      const processedData = location.state.usersList.map((user, index) => {
        return {
          SNO: index + 1,
          ...user,
          // Store the button text instead of a JSX element
          manage_rights: "Module Rights" // Changed to match column name
        };
      });

      setAllRows(processedData);
      setPendingRows(processedData);
      setCompletedRows(processedData);
    }
  }, [location.state]);

  // Handle user selection - fetch module rights and navigate
  const handleUserSelect = async (specCode) => {
    try {
      setLoading(true);
      // API call to get modules for this user
      const response = await axios.get(`https://metalzulu-backend.onrender.com/api/v1/dashboardadmin/get-modules/${specCode}`,
          {
            withCredentials: true,
          });
      
      if (response.data) {
        console.log("API Response:", response.data);
        
        // Navigate to modules rights page with the fetched data
        navigate('/admin/modules-rights', {
          state: {
            userModules: response.data, // Pass the entire response object
            specCode: specCode
          }
        });
      } else {
        message.error("Failed to fetch module rights data");
      }
    } catch (error) {
      console.error("Error fetching module rights:", error);
      message.error("Failed to fetch module rights for this user");
    } finally {
      setLoading(false);
    }
  };

  // Custom cell formatter for the SalesTable
  const customFormatter = (row, col) => {
    if (col === "manage_rights") {
      return (
        <button 
          className={classes["ActionButton"]} 
          onClick={() => handleUserSelect(row.spec_code)}
        >
          {row[col]}
        </button>
      );
    }
    return row[col];
  };

  const handleClick = (event, val) => {
    setTypeChanged(false);
    setType(val);
    setTypeChanged(true);
  };

  const onDChange = (value) => {
    setDFilter(value);
  };

  const onDateChange = (date, dateString) => {
    setFromDate(dateString[0]);
    setToDate(dateString[1]);
  };

  // Handle back button click
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <Row className={classes["Row"]}>
        <Col md={12}>
          <p className={classes["Title"]}>All Users</p>
        </Col>
        <Col className={classes["Col"]} md={10}>
          <Row className={classes["Row"]}>
            <Col lg={19} md={17}></Col>
            <Col className={classes["Col"]} lg={5} md={7}>
              <button
                onClick={handleBack}
                className={classes["ProfileButton"]}
              >
                Back
              </button>
            </Col>
          </Row>
        </Col>
      </Row>
      <p></p>
      <p></p>
      {loading ? (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      ) : typeChanged &&
        allRows &&
        completedRows &&
        pendingRows &&
        columns.length > 0 ? (
        <>
          {type === "all" && (
            <SalesTable 
              data={allRows} 
              columns={columns} 
              formatter={customFormatter} // Pass formatter function to SalesTable
            />
          )}
          {type === "pending" && (
            <SalesTable 
              data={pendingRows} 
              columns={columns} 
              formatter={customFormatter}
            />
          )}
          {type === "completed" && (
            <SalesTable 
              data={completedRows} 
              columns={columns} 
              formatter={customFormatter}
            />
          )}
        </>
      ) : (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      )}
    </>
  );
};

export default AllUsers;